import React from "react";
import { Button, Icon } from "semantic-ui-react";
// import "./cmp-session-timeout.css";

export default function CMP_IMPERSONATION_TIMEOUT({
  set_mdl_open,
  modalTitle = "Authentication Required",
  modalMessage = "Your session has changed or expired. Please log in again to continue.",
  onConfirm = () => {},
}) {
  function onClick() {
    onConfirm();
    set_mdl_open(false);
  }
  /* RENDER */
  return (
    <>
      {/* Header */}
      <div className="session-modal-header">
        <div
          style={{
            fontSize: "18px",
            fontWeight: "600",
          }}
        >
          {modalTitle}
        </div>
      </div>

      {/* Content */}
      <div className="session-modal-content">
        <img
          src="/session-timeout.svg"
          alt="Session Expired"
          style={{
            width: "80px",
            height: "80px",
            marginBottom: "12px",
          }}
        />
        <p className="confirmation_message">{modalMessage}</p>
      </div>

      {/* Footer */}
      <div className="modal-footer" style={{ justifyContent: "center" }}>
        <Button type="button" color="red" onClick={onClick}>
          <Icon name="arrow left" />
          Scheduler Home
        </Button>
      </div>
    </>
  );
}
